<div class="!mt-2 border-1 border-palette-gray-200 rounded-lg bg-white !p-4 font-inter">
    <div (click)="handleClickExpandCollapse(expandSeat)" (mouseover)="handleMouseOverLeave(expandSeat, true)"
        (mouseleave)="handleMouseOverLeave(expandSeat, false)"
        class="flex items-center justify-between cursor-pointer">
        <div class="flex items-center !gap-4">
            <img class="!h-[56px] aspect-square" src="assets/icons/step-payment/seat.svg" alt="">
            <p [ngClass]="{'!font-extrabold':expandSeat.isMouseOver}"
                class="text-lg font-semibold text-palette-gray-900">
                {{'FLIGHT.PAYMENT.SEAT_SELECTION' | translate}}
                <span class="font-inter text-sm !font-normal" *ngIf="count > 0 && !expandSeat.isExpand">({{ count }} {{ 'FLIGHT.SEAT_SELECTED' | translate }})</span>
            </p>
        </div>
        <i [ngClass]="{'sctr-icon-chevron-down':expandSeat.isExpand, 'sctr-icon-chevron-right':!expandSeat.isExpand, 'font-extrabold':expandSeat.isMouseOver}"
            class="text-xl leading-5 text-palette-gray-500"></i>
    </div>
    <div @slideDownUp *ngIf="expandSeat.isExpand"
        class="{{dataConvert.length > 1 ? '!grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-4' : ''}} !mt-4">
        <ng-container *ngIf="dataConvert.length; else seatNotIncluded">
            <ng-container *ngFor="let seatsSegment of dataConvert">
                <div class="!p-4 border border-palette-gray-200 bg-palette-gray-50 rounded-md">
                    <div class="flex items-center !gap-2 text-base !font-medium text-palette-gray-900">
                        <span>{{ seatsSegment[0]?.origin_iata_code }}</span>
                        <i class="sctr-icon-arrow-narrow-right text-[20px]"></i>
                        <span>{{ seatsSegment[0]?.destination_iata_code }}</span>
                    </div>
                    <div class="flex flex-col !gap-2 !mt-2">
                        <div *ngFor="let seat of seatsSegment"
                            class="flex justify-between !gap-2 text-sm">
                            <div class="relative flex-1">
                                <div class="line-clamp-1 text-sm text-palette-gray-700 max-w-full capitalize"
                                    [isTruncated]="true"
                                    [tooltip]="('COMMON.' + seat?.title?.toUpperCase() | translate) + ' ' + toFirstUppercase(seat?.last_name) + ' ' + toFirstUppercase(seat?.middle_and_first_name)">
                                    {{ 'COMMON.' + seat?.title?.toUpperCase() | translate }} {{ seat?.last_name | lowercase }} {{ seat?.middle_and_first_name | lowercase }}
                                </div>
                            </div>
                            <span class="font-medium text-palette-gray-900">{{ seat?.code}}</span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-template #seatNotIncluded>
            <div class="text-palette-gray-700 text-sm font-semibold">{{ 'COMMON.NOT_INCLUDED' | translate }}</div>
        </ng-template>
    </div>
</div>